export default {
  sign_out: 'Sign Out',
  cancel: 'Cancel',
  confirm: 'Confirm',
  refresh: 'Refresh',
  language: 'Language',
  settings: 'Settings',
  search: 'Search',
  uid_copied: 'UID copied',
  copy_blocked: 'Copy blocked',
  loading: 'Loading...',
  loading_more: 'Loading more...',
  all: 'All',
  unknown_error: 'Unknown error',
  notifications: 'Notifications',
  notification_details: 'Notification Details',
  notification_not_found: 'Notification not found',
  details: 'Details',
  no_notifications: 'No notifications yet',
  open: 'Open',
  support: 'Support',
  chat_now: 'Chat now',
  telegram: 'Telegram',
  livechat: 'LiveChat',
  login_register: 'Login/Register',
  // Separate actions for clients whose header carries both
  // buttons instead of one combined card (accountInHeader).
  login: 'Log In',
  register: 'Register',
  view_after_login: 'View after logging in',

  // Session kicked (code 4021)
  session_kicked_title: 'You have been logged out',
  session_kicked_body: 'This account has been logged in on another device, and the current device has been automatically logged out. If this was not done by you, please contact customer service immediately.',
  session_kicked_ok: 'OK, got it',
  weak_password_title: 'Your password is weak',
  weak_password_body: 'Your password is weak, please change your password.',
  weak_password_action: 'Change password',
  weak_password_logout: 'Log out',
  session_kicked_location_label: 'Login Location',
  session_kicked_country: 'Country',
  session_kicked_ip: 'IP Address',
  session_kicked_login_time: 'Login Time',

  // Accessibility labels
  aria_refresh_balance: 'Refresh balance',
  aria_show_balance: 'Show balance',
  aria_hide_balance: 'Hide balance',
  aria_back: 'Back',
  aria_close: 'Close',
  aria_exit: 'Exit',
  aria_favorite: 'Favorite',
  aria_live_updates: 'Live updates active',
};
